import { ComponentProps } from 'react';
import { ANDROID_MOBILE_APP_LINK, IOS_MOBILE_APP_LINK } from 'constants/links';
import AndroidBadge from 'images/google-play-badge.png';
import IOSBadge from 'images/ios-app-store-badge.png';

const WIDTH = 117;

const MobileAppBadges = (props: ComponentProps<'div'>) => {
    const { className = '', ...rest } = props;

    return (
        <div className={`flex h-auto flex-nowrap gap-4 ${className}`} {...rest}>
            <a className={'h-auto'} href={IOS_MOBILE_APP_LINK}>
                <img
                    className={'h-full'}
                    width={WIDTH}
                    src={IOSBadge}
                    alt={'Apple App Store badge'}
                />
            </a>
            <a className={'h-auto'} href={ANDROID_MOBILE_APP_LINK}>
                <img
                    className={'h-full'}
                    width={WIDTH}
                    src={AndroidBadge}
                    alt={'Google Play Badge'}
                />
            </a>
        </div>
    );
};

export { MobileAppBadges };
